import { useHistory, useLocation, useParams, useQuery } from 'react-router-dom'
import { useCallback } from 'react'
import CLIENT_ENDPOINTS from '../../constants/client-endpoints'
import QuerystringBuilder from '../../utilities/querystring-builder'
import urlBuilder from '../../utilities/url-builder'
import React from 'react'

const useClientLocation = () => {
    const history = useHistory()
    const location = useLocation()
    const params = useParams()
    const queryParams = new URLSearchParams(useLocation().search)

    const toLocation = useCallback(target => history.push(target), [history])

    const appendCurrentLocation = useCallback(target => {
        toLocation(`${location.pathname}${target}`)
    }, [location, toLocation])

    const studentUpcomingExperiences = useCallback(() => history.push(CLIENT_ENDPOINTS.STUDENT.UPCOMING_EXPERIENCES), [history])
    const studentAvailableExperiences = useCallback(() => history.push(CLIENT_ENDPOINTS.STUDENT.AVAILABLE_EXPERIENCES), [history])

    const userProfile = useCallback(userId => history.push(CLIENT_ENDPOINTS.USER.replace(':userId', userId)), [history])
    const toUserGoal = useCallback((userId, goalId = 'new') => {
        appendCurrentLocation(CLIENT_ENDPOINTS.USER_GOAL.replace(':goalId', goalId))
    }, [appendCurrentLocation])

    const toUserReflection = useCallback((promptId) => {
        appendCurrentLocation(CLIENT_ENDPOINTS.USER_REFLECTION.replace(':promptId', promptId))
    }, [appendCurrentLocation])

    const toNewUser = useCallback(() => history.push(CLIENT_ENDPOINTS.USERS_CREATE), [history])

    const toLearningResource = useCallback((resourceId) => history.push(CLIENT_ENDPOINTS.LEARNING_RESOURCE.replace(':resourceId', resourceId)), [history])

    const toExperience = useCallback((experienceId) => {
        appendCurrentLocation(CLIENT_ENDPOINTS.EXPERIENCE.replace(':experienceId', experienceId))
    }, [appendCurrentLocation])

    const toDropExperience = useCallback(() => {
        appendCurrentLocation(CLIENT_ENDPOINTS.DROP)
    }, [appendCurrentLocation])

    const toEnrollExperience = useCallback(() => {
        appendCurrentLocation(CLIENT_ENDPOINTS.ENROLL)
    }, [appendCurrentLocation])

    const toPreviewExperienceSchedule = React.useCallback(() => {
        appendCurrentLocation(CLIENT_ENDPOINTS.PREVIEW_SCHEDULE)
    }, [appendCurrentLocation])

    const toViewExperienceConflicts = React.useCallback(() => {
        appendCurrentLocation(CLIENT_ENDPOINTS.CONFLICTS)
    }, [appendCurrentLocation])

    const toSchedule = useCallback(() => history.push(CLIENT_ENDPOINTS.SCHEDULE), [history])
    const toCatalog = useCallback(() => history.push(CLIENT_ENDPOINTS.CATALOG), [history])

    const windowLocation = useCallback((url, newWindow = false) => {
        if(newWindow) {
            window.open(url)
        } else {
            window.location = url
        }
    })

    const toMessageUser = useCallback((userId, subject) => {
        const query = new QuerystringBuilder()
        query.addParam('userId', userId)
        query.addParam('subject', subject)
        appendCurrentLocation(`${CLIENT_ENDPOINTS.MESSAGE}${query.toString()}`)
    }, [appendCurrentLocation])

    const toMessageCourse= useCallback((courseId, subject) => {
        const query = new QuerystringBuilder()
        query.addParam('courseId', courseId)
        query.addParam('subject', subject)
        appendCurrentLocation(`${CLIENT_ENDPOINTS.MESSAGE}${query.toString()}`)
    }, [appendCurrentLocation])

    /**
     * Usage: toEndpoint(url, {userId: '123', foo: 'bar'}, { limit: 12 })
     */
    const toEndpoint = useCallback((endpoint, urlParams = {}, queryParams = {}) => {
        toLocation(urlBuilder(endpoint, urlParams, queryParams))
    }, [toLocation])

    return {
        
        location,
        windowLocation,
        studentUpcomingExperiences,
        studentAvailableExperiences,
        userProfile,
        toUserGoal,
        goBack: history.goBack,
        params,
        queryParams,
        toUserReflection,
        toNewUser,
        toLearningResource,
        toExperience,
        toDropExperience,
        toSchedule,
        toEnrollExperience,
        toCatalog,
        toMessageUser,
        toMessageCourse,
        toEndpoint,
        toPreviewExperienceSchedule,
        toViewExperienceConflicts,

        toLocation,
        endpoints: CLIENT_ENDPOINTS,
        url: urlBuilder
    }
}

export default useClientLocation